import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloudSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cloud-simple"} maskId="square-filled-radius-0-stroke-1-IconCloudSimple"><path d="M8.85 4C4.50509 4 1 7.59129 1 12C1 16.4087 4.50509 20 8.85 20H17.25C20.4351 20 23 17.3681 23 14.1429C23 10.9176 20.4351 8.28571 17.25 8.28571C16.7809 8.28571 16.3245 8.34304 15.8872 8.45131C14.6061 5.8179 11.9398 4 8.85 4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCloudSimple;
